import React from 'react';  
import './WhyChooseUs.css';
import { FaBolt, FaChartLine, FaLock } from 'react-icons/fa';

const WhyChooseUs = () => {
  const features = [
    {
      icon: <FaBolt />,
      title: 'Otomatis & Efisien',
      description: 'Buat invoice otomatis, kirim reminder, dan terima pembayaran tanpa repot. Hemat waktu hingga 80%.'
    },
    {
      icon: <FaChartLine />,
      title: 'Real-time Analytics',
      description: 'Dashboard lengkap dengan laporan keuangan real-time untuk monitoring cash flow dan revenue.'
    },
    {
      icon: <FaLock />,
      title: 'Aman & Terpercaya',
      description: 'Enkripsi data tingkat bank, compliance PCI-DSS, dan backup otomatis untuk keamanan maksimal.'
    }
  ];

  return (
    <section className="why-choose-us">
      <div className="container">
        <div className="section-header">
          <span className="section-label">MENGAPA ORION BILLING</span>
          <h2 className="section-title">Billing System yang Dikembangkan untuk Kemudahan Anda</h2>
          <p className="section-description">
            Solusi billing modern yang membantu bisnis mengelola invoice dan pembayaran dengan lebih efisien
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
